import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Auth } from 'aws-amplify';
import { folderStatuses } from '../constants/app-config';
import { InvoicesService } from '../preview/invoices/services/invoices.service';
import { log } from 'console';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-invoice-status-label',
  templateUrl: './invoice-status-label.component.html',
  styleUrls: ['./invoice-status-label.component.css']
})
export class InvoiceStatusLabelComponent implements OnInit{

  @Input() item: any;
  @Input() hideOnCreated:boolean = false;
  invoicesFolderID:string = '';
  folderStatuses = folderStatuses;
  folderStatus: any = null;
  folderId: any = null;
  user:any
  isSuccess: boolean = false;
  userID:any;


  constructor(public invoiceService: InvoicesService, private snackBar: MatSnackBar, private route: ActivatedRoute) { }

  async ngOnInit() {

    this.user = await Auth.currentAuthenticatedUser()
    this.userID = localStorage.getItem('userID')
    this.invoicesFolderID = this.route.snapshot.paramMap.get('id') as string    
    this.invoiceService.OnUpdateFolderListener(this.userID).subscribe((folders: any) => {

      if(folders.value.data.onUpdateFolder.id === this.item.id){
        this.item.status = folders.value.data.onUpdateFolder.status
        this.item.latestCompletedAt = folders?.value?.data?.onUpdateFolder?.latestCompletedAt
        this.item.createdAt = folders?.value?.data?.onUpdateFolder?.createdAt
      }
    })
  }

  isProcessing(status: any) {
    if (status === folderStatuses.IN_PROCESSING || status === folderStatuses.IN_QUEUE) {
      return true
    }
    return false
  }

  getStatus(item: any) {
    if (this.folderId && this.folderStatus && item.id === this.folderId) {
      return this.folderStatus
    }
    return item.status
  }

}
